import { memo, useMemo, useState } from "react";
import { splitMailHtml } from "../services/mail-html";
import styles from "./AgentMailbox.module.scss";

/**
 * Тело письма: очищенный HTML, цитата прошлой переписки свёрнута
 */
export const MailBody = memo(({ html }: { html: string }) => {
    const { body, quote } = useMemo(() => splitMailHtml(html), [html]);
    const [showQuote, setShowQuote] = useState(false);

    return (
        <div className={styles.postBody}>
            <div dangerouslySetInnerHTML={{ __html: body }} />
            {quote && (
                <>
                    <button
                        type="button"
                        className={styles.quoteToggle}
                        onClick={() => setShowQuote((v) => !v)}
                        title={showQuote ? "Скрыть цитату" : "Показать предыдущую переписку"}
                    >
                        •••
                    </button>
                    {showQuote && <div className={styles.quote} dangerouslySetInnerHTML={{ __html: quote }} />}
                </>
            )}
        </div>
    );
});
